/**
 * Authenticated fetch wrapper for all /api/ calls.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * 
 * Uses RELATIVE paths (e.g., '/api/auth/me') so requests always go to the current domain.
 * This ensures same-origin requests in preview, deployment, and local dev.
 * Adds Bearer token from localStorage and sends cookies via credentials: 'include'.
 */
export function apiFetch(path, options = {}) {
  const token = localStorage.getItem('session_token');

  const headers = {
    ...options.headers,
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };

  // Use relative path — browser resolves to current domain automatically
  // This avoids cross-origin issues between preview and deployed environments
  return fetch(path, {
    ...options,
    credentials: 'include',
    headers,
  });
}
